import react from "react";
import '../css/Common.css'
const PrivacyPolicy = () => {
    return (
        <div className="page-container">
            <h1>Privacy Policy</h1>
            <p>Your data is safe with us.</p>
            <ul>
                <li>We collect user data for service improvement.</li>
                <li>We do not share your data with third parties.</li>
                <li>Your information is securely stored.</li>
            </ul>
        </div>
    );
};
export default PrivacyPolicy;